import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const TopLoader = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [key, setKey] = useState(0);

  useEffect(() => {
    setVisible(true);
    setKey(k => k + 1);
    const timer = setTimeout(() => setVisible(false), 1800);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  if (!visible) return null;

  return (
    <div
      key={key}
      className="fixed top-0 left-0 z-[9999] h-[3px] animate-top-loader"
      style={{
        background: "linear-gradient(90deg, #677be6, #7450a9, #677be6)",
        backgroundSize: "200% 100%",
        boxShadow: "0 0 8px rgba(116, 80, 169, 0.6)",
      }}
    />
  );
};

export default TopLoader;
